import React from 'react';

import { RibbonButton } from 'common/components';

import { PicRightOutlined } from '@ant-design/icons';
import { useGlobalModal } from 'hooks';

const MoveAllToMember = (props) => {
  const { disabled } = props;

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const onClickMoveAllBtn = () => {
    openModal(MODAL_NAMES.TRANSFER_ALL_ENTITIES_TO_MEMBER);
  };

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<PicRightOutlined />}
        label={'Transfer All Entities to Member'}
        onClick={onClickMoveAllBtn}
        disabled={disabled}
      />
    </>
  );
};

export default MoveAllToMember;
